export { default } from './GameHeader';